var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-access"},[_c('h3',{staticClass:"wallet-title"},[_vm._v("No Access")]),_c('p',[_vm._v("Authentication invalid.")])])}]

export { render, staticRenderFns }